import { globalPut } from '../index';

export const editRevision = (data) => {
  return globalPut('/revision', data );
};